import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import lgnBg from "../../Assets/Login/bgcolor.jpg";
import logo from "../../Assets/Logos/logov.png";

export default function OtpVerificationPage({
 
  onClose,
  onLoginSuccess,
}) {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
//   console.log("email prop: ", email);
  const location = useLocation();
  const email = location.state?.email || "";
  console.log("email useLocation: ", email);
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Focus next input
    if (element.value && element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && e.target.previousSibling) {
      e.target.previousSibling.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/verify-otp-login`,
        { email, otp: otpValue }
      );

      toast.success("Login successful!");

      if (onLoginSuccess) {
        onLoginSuccess(response.data);
      } else {
        // Store token and redirect
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/dashboard");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "OTP verification failed";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setIsResending(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/resend-otp`,
        { email }
      );

      toast.success("New OTP sent to your email and mobile");
      setTimeLeft(300); // Reset timer to 5 minutes
      setOtp(["", "", "", "", "", ""]);

      // Focus first input
      document.getElementById("otp-0").focus();
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Failed to resend OTP";
      toast.error(errorMessage);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="w-full min-h-screen grid grid-cols-1">
      <div
        className="flex w-full justify-center items-center p-10 bg-cover bg-center"
        style={{ backgroundImage: `url(${lgnBg})` }}
      >
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
          <div className="flex justify-center items-center pb-8">
            <img src={logo} alt="logo" className="w-15 h-15" />
          </div>

          <h2 className="text-2xl font-semibold text-center mb-1">
            OTP Verification
          </h2>
          <p className="text-gray-500 text-center mb-2">
            Enter the 6-digit code sent to your email and mobile
          </p>
          <p className="text-gray-700 text-center mb-6 font-medium">{email}</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex justify-between space-x-2">
              {otp.map((data, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={data}
                  onChange={(e) => handleOtpChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-12 h-12 border-2 rounded-md text-center text-xl focus:border-blue-500 focus:outline-none"
                  autoFocus={index === 0}
                />
              ))}
            </div>

            <div className="text-center">
              {timeLeft > 0 ? (
                <p className="text-gray-600">
                  OTP expires in:{" "}
                  <span className="font-semibold">{formatTime(timeLeft)}</span>
                </p>
              ) : (
                <p className="text-red-600 font-semibold">OTP has expired</p>
              )}
            </div>

            <button
              type="submit"
              disabled={isLoading || timeLeft <= 0}
              className={`w-full ${
                isLoading || timeLeft <= 0
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-primary hover:bg-btnHover"
              } text-white py-3 rounded-md transition duration-200 font-semibold`}
            >
              {isLoading ? "Verifying..." : "Verify OTP"}
            </button>

            <div className="text-center">
              <button
                type="button"
                onClick={handleResendOtp}
                disabled={isResending || timeLeft > 0}
                className={`text-blue-600 hover:underline ${
                  isResending || timeLeft > 0
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
              >
                {isResending ? "Sending..." : "Resend OTP"}
              </button>
            </div>
          </form>

          <div className="text-center mt-4 pt-4 border-t border-gray-200">
            <button
              onClick={() => navigate("/login")}
              className="text-blue-600 hover:underline"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
